import React, { Component } from 'react';
import PropTypes from 'prop-types';
import bulletsMenuHOC from '../../common/bulletsMenuHOC';
import MenuListButton from '../../common/ui/MenuListButton';

class JobBulletsMenu extends Component {
  static propTypes = {
    cancelThisJob: PropTypes.func,
    navToDetails: PropTypes.func.isRequired,
    closeMenu: PropTypes.func.isRequired,
    isWorkerDetails: PropTypes.bool
  };

  cancel = e => {
    e.stopPropagation();
    this.props.closeMenu();
    this.props.cancelThisJob();
  };

  viewJob = e => {
    e.stopPropagation();
    this.props.navToDetails();
  };

  render () {
    const { jobIsNotEditable, isWorkerDetails } = this.props;
    return (
      <ul className='popupMenu job-bullets-menu'>
        <MenuListButton onClick={this.viewJob} name='View Job' />
        { !jobIsNotEditable && !isWorkerDetails && (
          <MenuListButton onClick={this.cancel} name='Cancel Job' className='cancel' />
        )}
      </ul>
    );
  }
}

export default bulletsMenuHOC(JobBulletsMenu);



// WEBPACK FOOTER //
// ./src/components/app/jobsList/JobBulletsMenu.js